var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 5.81V11.9L18.37 10.5C17.59 9.83 16.33 9.83 15.55 10.5L11.39 14.07C10.61 14.74 9.35 14.74 8.57 14.07L8.23 13.79C7.52 13.17 6.39 13.11 5.59 13.65L0.67 16.95L0.56 17.03C0.19 16.23 0 15.28 0 14.19V5.81C0 2.17 2.17 0 5.81 0H14.19C17.83 0 20 2.17 20 5.81Z",
    fill: "#0DBF0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.38012C8.31443 8.38012 9.38 7.31456 9.38 6.00012C9.38 4.68568 8.31443 3.62012 7 3.62012C5.68556 3.62012 4.62 4.68568 4.62 6.00012C4.62 7.31456 5.68556 8.38012 7 8.38012Z",
    fill: "#0DBF0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.8996V14.1896C20 17.8296 17.83 19.9996 14.19 19.9996H5.81C3.26 19.9996 1.42 18.9296 0.559998 17.0296L0.669998 16.9496L5.59 13.6496C6.39 13.1096 7.52 13.1696 8.23 13.7896L8.57 14.0696C9.35 14.7396 10.61 14.7396 11.39 14.0696L15.55 10.4996C16.33 9.82957 17.59 9.82957 18.37 10.4996L20 11.8996Z",
    fill: "#0DBF0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/gallery-icon.da5b842fc9eb432b9eae955f26d24588.svg";
export { ForwardRef as ReactComponent };